module.exports = __webpack_public_path__ + "img/sb03-08.43da4611.png";